var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/modules/_cof.js
// module id = 1376
// module chunks = 1